<template>
  <div>
      <section class="farmerContainer">
            <div class="container-fluid">
                <div class="col-12">
                    <div class="text-center padding_top_lg padding_bottom_lg margin_top_sm margin_bottom_md">
                        <h4 class="font-bold font-xl">Shopping cart</h4>
                        <h5 class="smallFonts margin_top_sm caps_upper color__grey_light">{{cart.length}} item(s)</h5>
                    </div>

                    <div class="row margin_top_md">
                        <div class="col-lg-8 cart-left">
                            <div class="cart-left-container">
                                <div class="row cart-left__header">
                                    <div class="col-4">
                                        <h6 class="caps_upper font-sm font-bold color__grey_light">Items</h6>
                                    </div>
                                    <div class="col-3">
                                    <h6 class="font-bold color__grey_light"><span class="caps_upper font_sm">Quantity</span> <small class="smallFont"> (tons)</small></h6>
                                    </div>
                                    <div class="col-2">
                                        <h6 class="font-bold color__grey_light"><span class="caps_upper font_sm">Price</span> <small class="smallFont"> (per ton)</small></h6>
                                    </div>
                                    <div class="col-3">
                                        <h6 class="caps_upper font_sm font-bold color__grey_light">Total</h6>
                                    </div>
                                </div>
                                <div class="row cart-last" v-for="(c, index) in cart" :key="index">
                                    <div class="col-12">
                                    
                                        <item-row :cartItem="c" @refresh="refresh" :key="toggle" />
                                
                                    </div>
                                </div>

                            </div>
                        </div>

                        <Summary />

                    </div>

                    <Footer />
                </div>
            </div>
            
        </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ItemRow from '@/components/off-taker/order/ItemRow';
import Summary from '@/components/off-taker/order/Summary';
import Footer from '@/components/off-taker/order/Footer';

export default {
    props: [],
    data() {
        return {
            toggle: false
        }
    },
    computed: {
        ...mapState('offtaker',['cart'])
    },
    methods: {
        ...mapActions('offtaker', ['addToCart']),
        refresh() {
            this.toggle = !this.toggle
            
        }
    },
    components: {
        ItemRow,
        Summary,
        Footer
    }
}
</script>

<style>

</style>